export default {
  quality: {
    default: 720,
    options: [360, 720, 1080],
  },
  settings: ['quality', 'speed'],
  controls: [
    'play',
    'progress',
    'current-time',
    'mute',
    'volume',
    'settings',
    'pip',
    'airplay',
    'fullscreen',
  ],
  fullscreen: {
    enabled: true,
    iosNative: true,
  },
}
